<template>
    <settings-popup-base
        :resources="{ 
            deleteButtonText: resource('JourneyBuilder_Button_DeleteCheckpoint'),  
            ...resources 
        }"
        :invalid="$v.$invalid"
        
        @hide="onHide($event)"
        @hidden="$emit('hidden')"
        @save="$emit('save')"
        @delete="deleteCheckpointWithPrompt()"
        @display-errors="$emit('display-errors')"
    >
        <template #title>
            <slot name="title" />
        </template>
        
        <template #body>
            <slot name="body" />

            <template v-if="canWrite && commentId">
                <hr />
                <h4>{{resource("JourneyBuilder_JourneyBrick_CommentHeader")}}</h4>
                <new-comment :brickId="commentId" id="newcomment" />
            </template>
        </template>
    </settings-popup-base>
</template>

<script>
import promptYesNo from '@modules/JourneyBuilder/Util/promptYesNo';

import {validationMixin} from 'vuelidate';
import resourceMixin from '@core/Util/Mixins/resources';
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

import SettingsPopupBase from "./SettingsPopupBase";
import {NewComment} from '@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments';

export default {
    name: "connection-settings-popup",
    components: {
        SettingsPopupBase,
        NewComment
    },
    mixins: [validationMixin, permissionsMixin, resourceMixin],
    
    props: {
        /**
         * @property {String} deletePromptTitle
         * @property {String} deletePromptBody
         * @property {String} deleteButtonText
         */
        resources: {
            type: Object,
            required: true
        },
        
        isNew: {
            type: Boolean,
            default: false,
            required: false
        },

        validations: {
            type: Object|Function,
            required: false,
            default: () => ({})
        },

        config: {
            required: false
        },
        
        commentId: {
            type: String,
            required: false
        }
    },

    //Will get added to $options property
    validations() {
        if(!this.validations){
            return undefined;
        }

        const validations = typeof this.validations === 'function' ?
            this.validations() :
            this.validations;

        return {
            config: validations
        }
    },

    methods: {
        onHide(evt){
            if(this.isNew){
                //Cancel selected - ask prior to actually removing checkpoint
                evt.continueAfter(async () => {
                    try {
                        await promptYesNo(
                            this.resource('JourneyComposer_CheckpointModal_CancelNewCheckpoint_Title'),
                            this.resource('JourneyComposer_CheckpointModal_CancelNewCheckpoint_Body')
                        );

                        this.deleteCheckpoint();
                    } catch(e) {
                        evt.preventDefault();
                    }
                });
            }
        },

        async deleteCheckpointWithPrompt(){
            try {
                await promptYesNo(
                    this.resources.deletePromptTitle,
                    this.resources.deletePromptBody
                );
            } catch(e) {
                //Cancelled - swallow and back out
                return;
            }

            this.deleteCheckpoint();
        },

        deleteCheckpoint() {
            this.$emit('delete');
        }
    }
}
</script>
